import type { RequestStatus } from '@features/request/requestSlice';
import { useResetStoreData } from '@features/request/useResetStoreData';
import type { BimcIsCalculationLimitedCostNameUniqueQueryVariables } from '@gql/graphql';
import type { Meta } from '@utils/types';
import { useRequest } from 'features/request/useRequest';

import type { PayloadAction } from '@reduxjs/toolkit';

import { bimcIsCalculationLimitedCostNameUniqueGql } from '../bimCalculationLimitedQueries';

const requestId = 'bimcIsUniqueNameLimitedCost';

export const useBimIsUniqueNameLimitedCost = (): {
    isUniqueNameRequest: (
        variables?: BimcIsCalculationLimitedCostNameUniqueQueryVariables,
        depsUpdater?: () => void,
    ) => PayloadAction;
    resetIsUniqueNameData: (value: unknown) => { payload: undefined; type: string } & { meta: Meta };
    isUniqueNameRequestStatus: RequestStatus;
    isUniqueName: boolean | null | undefined;
    isUniqueNameSetData: any;
} => {
    const [uniqueData, uniqueDataStatus, , isUniqueRequest, isUniqueNameSetData] = useRequest({
        requestId,
        query: bimcIsCalculationLimitedCostNameUniqueGql,
        withEffect: false,
    });

    const [resetIsUniqueData] = useResetStoreData({ requestId });

    return {
        isUniqueName: uniqueData?.bimcIsCalculationLimitedCostNameUnique?.isUnique,
        isUniqueNameRequestStatus: uniqueDataStatus,
        isUniqueNameRequest: isUniqueRequest,
        resetIsUniqueNameData: resetIsUniqueData,
        isUniqueNameSetData,
    };
};
